var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_320",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66667C7.70612 1.66667 5.83337 3.53942 5.83337 5.83333V8.33333C4.29536 8.33333 3.33337 9.60103 3.33337 10.6934V15.9717C3.33337 17.2653 4.40138 18.3333 5.69502 18.3333H14.3051C15.5987 18.3333 16.6667 17.2653 16.6667 15.9717V10.6934C16.6667 9.12393 15.3988 8.33333 14.1667 8.33333V5.83333C14.1667 3.53942 12.294 1.66667 10 1.66667ZM10 3.33333C11.3995 3.33333 12.5 4.43392 12.5 5.83333V8.33333H7.50004V5.83333C7.50004 4.43392 8.60062 3.33333 10 3.33333ZM5.69502 10H14.3051C14.7042 10 15 10.2942 15 10.6934V15.9717C15 16.3708 14.7042 16.6667 14.3051 16.6667H5.69502C5.29589 16.6667 5.00004 16.3708 5.00004 15.9717V10.6934C5.00004 10.2942 5.29589 10 5.69502 10Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_320)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.73914,
    y: -2.6087,
    width: 18.2609,
    height: 24.3478,
    fill: "#B1AEAE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/passwordIcon.99c75ae336a02b4b2ade9a8542cc77e7.svg";
export { ForwardRef as ReactComponent };